module.exports = __webpack_public_path__ + "img/29passenger_driving.d9f20eab.svg";